import { todayPT, withValidBusinessDays } from "@homebound/activesupport";
import { Chip } from "@homebound/beam";
import { ScheduleSettingDetailsFragment } from "src/fragments/circularFragments.generated";
import { DayOfWeek, ProgressSummaryStatus, TaskStatus } from "src/generated/graphqlTypes";
import { Temporal } from "temporal-polyfill";

type BaselineChipProps = {
  baselineDelta:
    | { actualDate: Temporal.PlainDate | undefined | null; baselineDate: Temporal.PlainDate | undefined | null }
    | {
        actualDuration: number | undefined | null;
        baselineDuration: number | null | undefined;
        baselineDate: Temporal.PlainDate | undefined | null;
      };
  status?: TaskStatus | ProgressSummaryStatus;
  scheduleSetting?: ScheduleSettingDetailsFragment | null | undefined;
};

export function BaselineChip({ baselineDelta, status, scheduleSetting }: BaselineChipProps) {
  const today = todayPT();
  const completed = status === TaskStatus.Complete;
  const { businessDays } = withValidBusinessDays({
    businessDays: [1, 2, 3, 4, 5, ...(scheduleSetting?.workingDays?.map((day) => dayOfWeekToIsoDay[day]) ?? [])],
  });
  const exceptions = scheduleSetting?.exceptions ?? undefined;
  let daysDiff = 0;

  if ("actualDate" in baselineDelta) {
    if (baselineDelta?.actualDate && baselineDelta?.baselineDate)
      daysDiff = baselineDelta.actualDate.differenceInBusinessDays(baselineDelta.baselineDate, {
        businessDays,
        exceptions,
      });
  } else {
    if (baselineDelta?.actualDuration && baselineDelta?.baselineDuration)
      daysDiff = baselineDelta.actualDuration - baselineDelta.baselineDuration;
  }

  const baselineDate = baselineDelta?.baselineDate;
  const delay =
    baselineDate && (baselineDate.isBefore(today) || baselineDate.equals(today)) && !completed && daysDiff > 0;
  const futureDelay = baselineDate && baselineDate.isAfter(today) && !completed && daysDiff > 0;

  return (
    <>{(delay || futureDelay) && <Chip type={futureDelay ? "caution" : "warning"} text={`${daysDiff}d`}></Chip>}</>
  );
}

const dayOfWeekToIsoDay: Record<DayOfWeek, number> = {
  [DayOfWeek.Monday]: 1,
  [DayOfWeek.Tuesday]: 2,
  [DayOfWeek.Wednesday]: 3,
  [DayOfWeek.Thursday]: 4,
  [DayOfWeek.Friday]: 5,
  [DayOfWeek.Saturday]: 6,
  [DayOfWeek.Sunday]: 7,
};
